import { DateType } from "../types";

function getDateDaysNumber(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

type WeekRow = { day: number; isCurrentMonth: boolean }[];

function getWeekRows({ year, month }: DateType): WeekRow[] {
  const numDays = getDateDaysNumber(year, month);
  const rows: WeekRow[] = [];
  let currentRow: WeekRow = [];

  const firstDay = new Date(year, month, 1);
  const startDayIndex = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;

  for (let i = startDayIndex - 1; i >= 0; i--) {
    const prevDate = new Date(year, month, -i);
    currentRow.push({ day: prevDate.getDate(), isCurrentMonth: false });
  }

  for (let i = 1; i <= numDays; i++) {
    currentRow.push({ day: i, isCurrentMonth: true });

    if (currentRow.length === 7) {
      rows.push(currentRow);
      currentRow = [];
    }
  }

  if (currentRow.length > 0) {
    let nextDay = 1;
    while (currentRow.length < 7) {
      currentRow.push({ day: nextDay++, isCurrentMonth: false });
    }
    rows.push(currentRow);
  }

  return rows;
}

function getMonday(year: number, month: number, row: WeekRow): Date {
  const mondayCell = row[0];
  if (mondayCell.isCurrentMonth) {
    return new Date(year, month, mondayCell.day);
  }
  if (row.some((cell) => cell.isCurrentMonth)) {
    return new Date(year, month - 1, mondayCell.day);
  }
  return new Date(year, month + 1, mondayCell.day);
}

function getDaysTexts(t: Function) {
  return [
    t("calendar.monday"),
    t("calendar.tuesday"),
    t("calendar.wednesday"),
    t("calendar.thursday"),
    t("calendar.friday"),
    t("calendar.saturday"),
    t("calendar.sunday"),
  ];
}

export { getWeekRows, getMonday, getDaysTexts };
export type { WeekRow };
